import CatSelect from "../../cat/CatSelect"
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";

export function GrpBasic({grp,courseId,onChange})
{
    const {t}=useTranslation();
    const [name,setName]= useState(grp.name);
    const [catId,setCatId]=useState(grp.catId);

    useEffect(()=>{
        console.log('GrpBasic:construstor');
    },[]);
    const changed=(q)=>{
        onChange(q);
    };
    const onNameChange=(e)=>{
        setName(e.target.value); 
        changed({name:e.target.value});
    };
    const onCatSelect=(cat)=>{
        setCatId(cat.id);
        changed({catId:cat.id});
    }
    return(
        <>
			<div className="formgrid grid p-2 pt-4 surface-ground">
				<div className="field col-12">
					<CatSelect inputId="catSelect" className="w-full" value={catId} parentId={courseId} onSelect={onCatSelect}></CatSelect>
				</div>
				<div className="flex align-items-center md:col-6">
                    <label htmlFor="name" class="col-fixed" style={{width:'100px'}}>{t('Question_Group_Name')}</label>
                    <div class="col"><InputText inputId="name" value={grp.name} onChange={onNameChange}></InputText></div>					
				</div>
			</div>
        </>
    )
}